import styles from './index.module.css'
import { useEffect, useRef, useState } from 'react'
import { VmsModalPopup } from '@/components/vms-components/ModalPopup/index'
import { VmsButton } from '@/components/vms-components/button/index'
import { VmsInputText } from '@/components/vms-components/InputText/index'
import { VmsModalOverlay } from '../../../vms-components/ModalOverlay'
import { useRouter } from 'next/router'

export default function Index(props) {
  const { setOpenShare, openShare, isMobile, shareId, displayCopyInput = true, partUrl } = props

  const inputRef = useRef(null)
  const [isCopied, setIsCopied] = useState(false)
  const [link, setLink] = useState('')

  const router = useRouter()

useEffect(() => {
  if (!router.isReady) return;
  const origin = window.location.origin;
  const cleanPartUrl = partUrl.replace(/^https?:\/\/[^/]+/, '').replace(/^\//, '');
  const fullUrl = `${origin}/${cleanPartUrl}`;
  setLink(fullUrl);
}, [router.isReady, shareId, partUrl]);

  console.log('link', link)

  const shareOptions = [
    {
      id: 'whatsapp',
      icon: 'images/te_whatsapp.png',
      title: 'WhatsApp',
      status: true,
      link: {
        mobile: `whatsapp://send?text=${encodeURIComponent(link)}`,
        desktop: `https://web.whatsapp.com/send?text=${encodeURIComponent(link)}`,
      },
    },
    {
      id: 'facebook',
      icon: 'images/te_facebook.png',
      title: 'Facebook',
      status: true,
      link: {
        all: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
      },
    },
    {
      id: 'linkedin',
      icon: 'images/te_linkedin.png',
      title: 'LinkedIn',
      status: true,
      link: {
        all: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`,
      },
    },
    {
      id: 'instagram',
      icon: 'images/te_instagram.png',
      title: 'Instagram',
      status: true,
      link: {
        all: `https://www.instagram.com/`, // no direct link sharing
      },
    },
    {
      id: 'gmail',
      icon: 'images/te_gmail.png',
      title: 'Gmail',
      status: true,
      link: {
        all: `mailto:?subject=Check this out&body=${encodeURIComponent(link)}`,
      },
    },
  ]

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(link)
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 3000)
    } catch (err) {
      if (inputRef.current) {
        inputRef.current.select()
        document.execCommand('copy')
        setIsCopied(true)
        setTimeout(() => {
          setIsCopied(false)
        }, 3000)
      }
    }
  }

  const handleShare = (option) => {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    const url = option?.link?.all || (isMobileDevice ? option?.link?.mobile : option?.link?.desktop)
    if (url) {
      window.open(url, '_blank')
      setOpenShare(false)
    }
  }

  const ModalComponent = isMobile ? VmsModalOverlay : VmsModalPopup
  const modalProps = isMobile
    ? {
      isOpen: openShare,
      onModalClose: () => setOpenShare(false),
      additionalClassName: styles.modalPopup,
    }
    : {
      isOpen: openShare,
      additionalClassName: styles.modalPopup,
    }

  const modalHeader = () => (
    <div className={styles.modal_header}>
      <div className={styles.modal_title}>
        {isMobile ? 'Share' : 'Share link'}
      </div>
      <button
        className={styles.modal_close_btn}
        onClick={() => setOpenShare(false)}
      >
        <img src="images/te_btn_blue_Close.svg" alt="Close" />
      </button>
    </div>
  )

  return (
    <div className={styles.shareContainer}>
      <ModalComponent {...modalProps}>
        {modalHeader()}
        <div className={styles.modalContent}>
          <div
             className={`${styles.inputContainer} ${
              isMobile
                ? styles.socialButtonsContainer
                : displayCopyInput
                  ? styles.inputContainer
                  : ''
            }`}
          >
            {/* {isMobile ? (
              shareOptions
                .filter((opt) => opt.status)
                .map((opt) => (
                  <button
                    key={opt.id}
                    className={styles.socialButton}
                    title={opt.title}
                    onClick={() => handleShare(opt)}
                  >
                    <img src={opt.icon} alt={opt.title} width={40} height={40} />
                  </button>
                ))
            ) : ( */}
              <>
                {displayCopyInput && (
                  <>
                    <VmsInputText
                      type="text"
                      value={link}
                      readOnly
                      inputRef={inputRef}
                      className={styles.linkInput}
                    />
                    <VmsButton size="small" onClick={handleCopyLink} disabled={isCopied}>
                      {isCopied ? 'Copied' : 'Copy Link'}
                    </VmsButton>
                  </>
                )}
              </>
            {/* )} */}
          </div>

          {/* {isMobile ? (
            <>
              <div className={styles.divider} />
              <div className={styles.mobileActions}>
                <VmsButton
                  size="small"
                  onClick={handleCopyLink}
                  className={styles.actionBtn}
                  disabled={isCopied}
                >
                  <span className={styles.mob_action_icon}>
                    <img src="images/te_copy.svg" alt="Copy" />
                  </span>
                  {isCopied ? 'Copied' : 'Copy link'}
                </VmsButton>
                <VmsButton size="small" className={styles.actionBtn}>
                  <span className={styles.mob_action_icon}>
                    <img src="images/te__share.svg" alt="share" />
                  </span>
                  Quick Share
                </VmsButton>
              </div>
            </>
          ) : ( */}
            <>
               {/* {displayCopyInput &&  */}
               <div className={styles.shareOnText}>Or share on</div>
               {/* } */}
              <div className={styles.socialButtonsContainer}>
                {shareOptions
                  .filter((opt) => opt.status)
                  .map((opt) => (
                    <button
                      key={opt.id}
                      className={styles.socialButton}
                      title={opt.title}
                      onClick={() => handleShare(opt)}
                    >
                      <img src={opt.icon} alt={opt.title} width={40} height={40} />
                    </button>
                  ))}
              </div>
            </>
          {/* )} */}
        </div>
      </ModalComponent>
    </div>
  )
}
